import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& $superheading': {
      color: TextColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    color: TextColors.light,

    '& $superheading': {
      color: TextColors.light,
    },
  },
};

const alignments = {
  '&.align-center': {
    alignItems: 'center',
    alignContent: 'center',

    '& $wrapper': {
      alignItems: 'center',
      alignContent: 'center',
      textAlign: 'center',
    },
  },
  '&.align-right': {
    alignItems: 'flex-end',
    alignContent: 'flex-end',

    '& $wrapper': {
      alignItems: 'flex-end',
      alignContent: 'flex-end',
      textAlign: 'right',
    },
  },
  '&.align-left': {
    alignItems: 'flex-start',
    alignContent: 'flex-start',

    '& $wrapper': {
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      textAlign: 'left',
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      ...alignments,

      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      height: '100%',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',

      '&': {
        [muiTheme.breakpoints.up('md')]: {
          width: '50%',
          '&.full-width-content': {
            width: '100%',
          },
        },
      },
    },
    superheading: {
      '&.MuiTypography-root': {
        '&:not(:last-child)': {
          marginBottom: muiTheme.spacing(1),
        },
      },
    },
    headlineContainer: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(2),
      },
    },
    headline: {
      '& *, & p, & h1, & h2, & h3, & h4, & h5, & h6': {
        ...muiTheme.typography.h2,
        lineHeight: '1.1em',
      },

      '& *': {
        marginTop: '0',
        marginBottom: '0',
      },
    },
    subheadingContainer: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    subheading: {
      '& *, & p': {
        ...muiTheme.typography.h6,
      },

      '& *': {
        marginTop: '0',
        marginBottom: '0',
      },
    },
    ctas: {
      margin: muiTheme.spacing(-1.5),
      display: 'flex',
      flexWrap: 'wrap',

      '& > .buttonWrapper': {
        padding: muiTheme.spacing(1.5),

        '& > *': {
          width: '100%',
        },

        [muiTheme.breakpoints.down('xs')]: {
          width: '100%',
        },
      },
    },
  }),
  { name: 'GenHeroLandingPage' },
);

export default useStyles;
